import * as XLSX from "xlsx";
import { Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import TablePage from "../../../../../components/pages/TablePage";
import { useDispatch } from 'react-redux';
import { useState } from "react";
import moment from "moment";
import { PostAPI } from "../../../../../redux";

const ImportInTabs = () => {
    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState(moment().unix());

    const columns = [
        {
            selector: (row) => row?.master_awb,
            name: "Master AWB"
        },
        {
            selector: (row) => row?.house_awb,
            name: "House AWB"
        },
        {
            selector: (row) => row?.no_dok_inout,
            name: "No Dok Inout"
        },
        {
            selector: (row) => row?.tgl_dok_inout,
            name: "Tgl Dok Inout"
        },
        {
            selector: (row) => moment(row?.createdAt).format('DD-MMM-YYYY'),
            name: "Date",
            id: 'date'
        },
    ];

    const handleUpload = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: "binary" });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                if (!json.length) {
                    message.error("Excel kosong atau tidak memiliki data.");
                    return;
                }

                const requiredHeaders = ["MAWB", "HAWB", "NO_DOK_INOUT", "TGL_DOK_INOUT"];
                const sheetHeaders = Object.keys(json[0] || {});
                const missingHeaders = requiredHeaders.filter(h => !sheetHeaders.includes(h));
                if (missingHeaders.length > 0) {
                    message.error(`Excel tidak sesuai dengan template`);
                    return;
                }

                const hasInvalidDocDate = json.some((row) => {
                    const rawValue = row["TGL_DOK_INOUT"];
                    const docDate = typeof rawValue === 'string' ? rawValue.trim() : '';
                    return !docDate || !moment(docDate, 'DD-MM-YYYY', true).isValid();
                });

                if (hasInvalidDocDate) {
                    message.error('Format TGL DOK INOUT pada data harus DD-MM-YYYY.');
                    return;
                }

                const formatted = json.map((row) => ({
                    master_awb: row["MAWB"] || "",
                    house_awb: row["HAWB"] || "",
                    no_dok_inout: row["NO_DOK_INOUT"] || "",
                    tgl_dok_inout: row["TGL_DOK_INOUT"] || "",
                }));

                const url = 'api/v1/import_verify/save';
                const uploadPromises = formatted.map((item) =>
                    dispatch(PostAPI({ url, data: { ...item, isCreate: true } }))
                );

                Promise.all(uploadPromises)
                    .then((responses) => {
                        const successCount = responses.filter(r => r?.payload).length;
                        message.success(`${successCount} data berhasil dikirim!`);
                        setRefresh(moment().unix());
                    })
                    .catch((err) => {
                        console.error("Upload error:", err);
                        message.error("Gagal upload beberapa data.");
                    });

            } catch (err) {
                console.error("Error parsing Excel:", err);
                message.error("Gagal parsing Excel file.");
            }
        };
        reader.readAsBinaryString(file);
        return false;
    };

    return (
        <div>
            <div style={{ marginBottom: 16 }}>
                <Upload
                    beforeUpload={handleUpload}
                    accept=".xlsx,.xls"
                    showUploadList={false}
                >
                    <Button icon={<UploadOutlined />}>Upload Excel</Button>
                </Upload>
            </div>
            <TablePage
                title="Import Doc Verify"
                url="api/v1/import_verify"
                actionPosition="right"
                createPath="/import/import_verify/create"
                editPath={"/import/import_verify/edit"}
                columns={columns}
                refresh={refresh}
            />
        </div>
    );
};

export default ImportInTabs;
